import axios from 'axios';
import { getCountryDataList, type ICountryData } from 'countries-list';
import { useState } from 'react';
import { aadConfig, getAccessToken } from '../aad';
import type { Address, IPGeolocationResponse } from '../dto/account';
import apiProxy from './apiProxy';

export const lookupAddress = apiProxy(
  'lookupAddress',
  async (query: string, countrySet?: string, idxSet?: string): Promise<Address[]> => {
    await getAccessToken(aadConfig().accountScopes);

    const params: string[] = [`query=${encodeURIComponent(query)}`];
    if (countrySet) params.push(`countrySet=${encodeURIComponent(countrySet)}`);
    if (idxSet) params.push(`idxSet=${encodeURIComponent(idxSet)}`);
    const { data } = await axios.get<any>(`${process.env.SUPPORT_HOST}/v1/maps/fuzzy-search?${params.join('&')}`);

    return data.results.map((item: any) => ({
      ...(item.address || {}),
      type: item.type,
      lat: item.position?.lat,
      lon: item.position?.lon,
    }));
  },
);

export const getGeolocation = apiProxy('getGeolocation', async (): Promise<IPGeolocationResponse> => {
  try {
    const request = await fetch(`https://api.geoapify.com/v1/ipinfo?&apiKey=a5c3c1b35b274971a10374674bfc70bd`);
    return await request.json();
  } catch (error) {
    return {
      country: {
        geoname_id: 6252001,
        iso_code: 'US',
        names: {
          en: 'United States',
        },
        name: 'United States',
        name_native: 'United States',
        phone_code: '1',
        capital: 'Washington D.C.',
        currency: 'USD,USN,USS',
        flag: '🇺🇸',
        languages: [
          {
            iso_code: 'en',
            name: 'English',
            name_native: 'English',
          },
        ],
      },
    };
  }
});

export type { ICountryData };
export const useCountries = (): ICountryData[] => {
  const [countries] = useState(getCountryDataList());
  countries.sort((a, b) => a.name.localeCompare(b.name));
  return countries;
};
